export default __webpack_public_path__ + "static/media/loginBackground.29a7e599.jpg";